import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
// import OperatorEdit from './operator-edit'
import ClientList from './client-list'
import ClientAdd from './client-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Client = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.CLIENT}
                        component={ClientList}
                    />
                    {/* <Route
                        exact
                        path={ROUTES.OPERATOR_EDIT}
                        component={OperatorEdit}
                    /> */}
                    <Route
                        exact
                        path={ROUTES.CLIENT_ADD}
                        component={ClientAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Client)



// WEBPACK FOOTER //
// ./src/pages/client/index.js